<template>
  <div class="ViewPromo" ref="container">
    <view-top :title="title" :desc="desc" :id="id"></view-top>
    <view-how-cards class="ViewPromo__section"></view-how-cards>
    <view-promo-products
      :id="id"
      :productId="productId"
      class="ViewPromo__section"
    ></view-promo-products>

    <div class="ViewPromo__section">
      <div class="ViewDieselInfo">
        <div class="ViewDieselInfo__row">
          <div class="ViewDieselInfo__col">
            <div class="ViewDieselInfo__content">
              <h2 class="ViewDieselInfo__title">{{ name }}</h2>
              <div class="ViewDieselInfo__inn">ИНН {{ inn }}</div>
              <div class="ViewDieselInfo__text app-typography">
                <h4>О компании:</h4>
                <p>
                  ООО «Кар Микс» — многопрофильная компания, одним из
                  направлений деятельности которой является оптовая реализация
                  нефтепродуктов и СУГ.
                </p>

                <p>
                  Компания «Кар Микс» сотрудничает только с проверенными
                  производителями и поставщиками. Продукция поставляется по
                  прямым контрактам с заводов-изготовителей, а также
                  приобретается через международную товарно-сырьевую биржу
                  «СПбМТСБ» у крупнейших производителей России: «Роснефть»,
                  «Газпромнефть», «Танеко» и др.
                </p>
                <p>
                  Качество нефтепродуктов подтверждается сертификатами и
                  паспортами качества. География работы компании — Рязанская
                  область, Липецкая область, Тамбовская область, Воронежская
                  область и другие регионы ЦФО.
                </p>
              </div>
            </div>
          </div>
          <div class="ViewDieselInfo__col">
            <div class="ViewDieselInfo__advantages-wrapper">
              <ul class="ViewPromo__advantages">
                <li class="ViewPromo__advantage">
                  <div class="ViewPromo__advantage-icon">
                    <app-svg-icon
                      name="iphone"
                      class="ViewPromo__advantage-icon-svg"
                    ></app-svg-icon>
                  </div>
                  <div class="ViewPromo__advantage-text">
                    <h4 class="ViewPromo__advantage-title">
                      Данные поставщика
                    </h4>
                    <p>
                      Телефон компании:<br />
                      <strong
                        ><a
                          href="tel:89156164192"
                          class="ViewPromo__advantage-contact-link"
                          >8 (915) 616-41-92</a
                        ></strong
                      >
                    </p>
                    <p>
                      Адрес электронной почты:<br />
                      <strong
                        ><a
                          href="mailto:info@karmix.ru"
                          class="ViewPromo__advantage-contact-link"
                          >info@karmix.ru</a
                        ></strong
                      >
                    </p>
                  </div>
                </li>
                <li class="ViewPromo__advantage">
                  <div class="ViewPromo__advantage-icon">
                    <app-svg-icon
                      name="lock-pin"
                      class="ViewPromo__advantage-icon-svg"
                    ></app-svg-icon>
                  </div>
                  <div class="ViewPromo__advantage-text">
                    <h4 class="ViewPromo__advantage-title">Базис поставок</h4>
                    <p>НБ «Кар Микс»</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <view-oil-scheme class="ViewPromo__section"></view-oil-scheme>
    <view-safe-advantages class="ViewPromo__section"></view-safe-advantages>
    <view-advantages class="ViewPromo__section"></view-advantages>
    <view-landing-buttons class="ViewPromo__section"></view-landing-buttons>
  </div>
</template>

<script>
export default {
  name: 'ViewPromo',
  inject: ['responsive'],
  components: {
    ViewPromoProducts: () =>
      import('@/pages/static/components/ViewPromoProducts.vue'),
    ViewSafeAdvantages: () =>
      import('@/pages/static/components/ViewSafeAdvantages'),
    ViewTop: () => import('@/pages/static/components/ViewTop'),
    ViewAdvantages: () => import('@/pages/static/components/ViewAdvantages'),
    ViewOilScheme: () => import('@/pages/static/components/ViewOilScheme'),
    ViewLandingButtons: () =>
      import('@/pages/static/components/ViewLandingButtons'),
    ViewHowCards: () => import('@/pages/static/components/ViewHowCards'),
    AppSvgIcon: () => import('@/components/common/AppSvgIcon'),
  },
  data: () => ({
    title: 'Топливо оптом онлайн от поставщика ООО «Кар Микс»',
    desc: 'на платформе OPEN OIL MARKET',
    id: 1250,
    productId: 2191,
    name: 'ООО «Кар Микс»',
    inn: '6220008581',
  }),
};
</script>
